/**
 * Check if item is type image or ots to set the displayed genre.
 * See: https://jira.mecom.de/browse/EC-5830
 */
export default function getGenre(genre, guid, residref = null) {
  if (residref) return "Bild";
  if (guid.includes("newsaktuell")) return "ots";
  return genre[0];
}
